import Vue from 'vue'
import VueRouter from 'vue-router'

import login from '../pages/login'

import index from '../pages/console/index'
import user from '../pages/user/index'

import admin from '../pages/admin/index'
import add_admin from '../pages/admin/add'
import edit_admin from '../pages/admin/edit'
import consult from '../pages/consult/index'
import consult_detail from '../pages/consult/detail'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [{
            path: '/login',
            name: '登录',
            component: login
        },
        {
            path: '/',
            name: '主页',
            component: index,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/user',
            name: '用户档案',
            component: user,
            meta: {
                keepAlive: true
            }
        },{
            path: '/admin',
            name: '医生列表',
            component: admin,
            meta: {
                keepAlive: true
            }
        }, {
            path: '/consult',
            name: '咨询线索',
            component: consult,
            meta: {
                keepAlive: true
            }
        }, {
            path: '/consult-detail',
            name: '咨询线索详情',
            component: consult_detail,
            meta: {
                keepAlive: false
            }
        }, {
            path: '/add-admin',
            name: '添加医生',
            component: add_admin,
            meta: {
                keepAlive: false
            }
        }, {
            path: '/edit-admin',
            name: '编辑医生',
            component: edit_admin,
            meta: {
                keepAlive: false
            }
        }
    ]
})
router.beforeEach(function (to, from, next) {
    let token = localStorage.getItem('token')
    //未登录
    if (!token) {
        if (to.path !== '/login') {
            return next({
                path: '/login',
                name: '登录'
            })
        }
        next()
    }
    // 已登录的情况再去登录页，跳转至首页
    if (to.path === '/login') {
        if (token) {
            return next({
                path: '/',
                name: '主页'
            })
        } else {
            return next({
                path: '/login',
                name: '登录',
            })
        }
    }
    next()
})
export default router
